import * as React from 'react';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { FilterOutlined } from '@ant-design/icons';

import { TableFiltersBar } from 'common/components/TableFiltersBar';
import { FilterDrawer } from 'common/components/FilterDrawer';
import { defaultPagination } from 'config/variables';
import { paginationRequest } from 'features/pagination/actions/paginationActions';
import { PaginationView } from 'features/pagination/models/paginationModel';
import { AppAction } from 'common/actions/appAction';

import { DashboardFilterDrawerContainer } from '../containers/DashboardFilterDrawerContainer';

type Props = {
    backUrl: string;
    filterId: PaginationView;
    /**
     * Same action each dashboard hands to its PaginatedTable. Typed permissively so the
     * per-dashboard row types stay assignable, exactly as PaginationSuccessCallback is
     * used across the paginated tables.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    paginationSuccessCallback?: (data: any[]) => AppAction;
};

export const DashboardTableFiltersBar: React.FunctionComponent<Props> = ({
    backUrl,
    filterId,
    paginationSuccessCallback,
}) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const close = () => setIsOpen(false);
    const dispatch = useDispatch();

    /**
     * Applying or resetting the filters only writes them to the store; PaginatedTable fetches
     * on mount and on page change, so without this the table kept showing the previous results
     * until the user navigated away and back. Refetch from page one with the new filters.
     */
    const refetch = paginationSuccessCallback
        ? () =>
              dispatch(
                  paginationRequest({
                      view: filterId,
                      pagination: { current: defaultPagination.firstPage },
                      paginationSuccessCallback,
                  }),
              )
        : undefined;

    return (
        <>
            <TableFiltersBar
                leftButtons={[
                    <Button
                        type="primary"
                        icon={<FilterOutlined />}
                        onClick={() => setIsOpen(true)}
                    >
                        Filters
                    </Button>,
                ]}
            />
            <FilterDrawer visible={isOpen} onClose={close}>
                {isOpen && (
                    <DashboardFilterDrawerContainer
                        backUrl={backUrl}
                        filterId={filterId}
                        onClose={close}
                        onApply={refetch}
                    />
                )}
            </FilterDrawer>
        </>
    );
};
